import React, { useContext } from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { useTranslation, Trans } from 'react-i18next';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import UserLink from '../../../User/Link/UserLink';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { formatDate, DATE_FORMATS } from '../../../Timestamp/functions';
import LegacyTextRenderer from '../../../TextRenderer/LegacyTextRenderer';
import deviationFlagStyles from './DeviationFlags.scss';
const DailyDeviationCard = ({ dailyDeviation: { body , time , giver , suggester  }  })=>{
    const { t  } = useTranslation();
    const { isLoggedIn  } = useContext(SessionContext);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(deviationFlagStyles['flag-block'], deviationFlagStyles['open'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(deviationFlagStyles['flag'], deviationFlagStyles['green'])
    }), /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['content']
    }, /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['title']
    }, t('actionbar.flags.dailyDeviation')), /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['open-only']
    }, /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['time'],
        suppressHydrationWarning: true
    }, t('actionbar.flags.givenOn', {
        date: formatDate(time, DATE_FORMATS.Date.Full)
    })), /*#__PURE__*/ React.createElement(LegacyTextRenderer, {
        className: deviationFlagStyles['body'],
        html: body
    }), /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['attribution']
    }, /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['giver']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "actionbar.flags.featuredBy"
    }, "Featured by ", /*#__PURE__*/ React.createElement(UserLink, {
        user: giver,
        className: deviationFlagStyles['link']
    }))), suggester && /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['suggester']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "actionbar.flags.suggestedBy"
    }, "Suggested by ", /*#__PURE__*/ React.createElement(UserLink, {
        user: suggester,
        className: deviationFlagStyles['link']
    })))), isLoggedIn && /*#__PURE__*/ React.createElement(TextButton, {
        href: Url.browseDailyDeviationsLink(),
        size: "medium",
        variant: "approval-green",
        noHorizontalPaddings: false
    }, t('actionbar.flags.seeAll')))));
};
DailyDeviationCard.displayName = 'DailyDeviationCard';
export default DailyDeviationCard;
